;
define("cart_lines.tpl", function(){});

